<!--
 * @Description: 搜索列表页
 * @Author: 山淑兰
 * @Date: 2019-09-10 10:05:16
 * @LastEditTime: 2020-07-02 14:11:41
 * @LastEditors: 山淑兰
 -->
<template>
  <div class="searchlist">
    <div class="loading" v-if="loading">
      <van-loading
        type="spinner"
        color="#3b82f6"
        vertical
        size="30px"
        text-size="16px"
        >加载中...</van-loading
      >
    </div>
    <div v-else>
      <div class="searchlist-con">
        <div class="details-return"  @click="goBack()">
          <img src="../../../assets/back.png">  
        </div>
       <!--  <div class="searchlist-title">
          {{ $t('meeting.header.search.agenda') }}
        </div> -->
        <template v-if="$i18n.locale == 'zh-CN'">
            <div class="details-main">
              <div v-for="(item, index) in datas" :key="index">
                <div class="details-main-head">
                  <van-cell
                    :title="item[0].createdTime"
                    icon="send-gift-o"
                    class="details-main-head-date"
                  />
                  <div class="details-list-num">{{ item[0].total }}</div>
                </div>
                <van-cell
                  class="details-main-con"
                  v-for="(i, id) in item"
                  :key="id"
                >
                  <van-cell icon="underway-o" class="major-title" :class="i.url!=null?'majorTitlePr':''">
                    {{ i.startTime + '-' + i.endTime }} {{ i.roomTitle }}
                  </van-cell>
                  <!-- <van-cell
                    icon="underway-o"
                    class="major-title" :class="i.url!=null?'majorTitlePr':''"
                    v-if="i.startTime"
                    >{{ i.startTime + '-' + i.endTime }}</van-cell
                  > -->
                  <a :href="i.url" target="_top" v-if="i.roomName">
                    <van-cell
                      icon="location-o"
                      class="major-title" :class="i.url!=null?'majorTitlePr':''"
                      
                      >{{ i.roomName }}</van-cell
                    ></a
                  >
                  <van-cell icon="orders-o" class="major-title" :class="i.url!=null?'majorTitlePr':''">
                     <span v-html="nToBr(i.topic)"></span>
                  </van-cell>
                  <van-cell
                    class="major-title" :class="i.url!=null?'majorTitlePr':''"
                    icon="user-o"
                    v-for="(it, is) in i.exData"
                    :key="is"
                  >
                    <div>
                      {{ it.rolename }}
                    </div>
                    <div>
                      <span
                        v-for="(s, j) in it.exname"
                        :key="j"
                        @click="todetails(it.exid[j])"
                      >
                        <span v-html="nToBr(s)" style="margin-right: 5px;"></span>
                      </span
                      >
                    </div>
                  </van-cell>
                  <div class="meeting-icon" v-if="i.url!=null">
                    <a :href="i.url" target="_top">
                      <img src="../../../assets/creame2.png">  
                      <p>点击观看直播</p>
                    </a>
                  </div>
                </van-cell>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="details-main">
              <div v-for="(item, index) in datas" :key="index">
                <div class="details-main-head">
                  <van-cell
                    :title="item[0].createdTime"
                    icon="send-gift-o"
                    class="details-main-head-date"
                  />
                  <div class="details-list-num">{{ item[0].total }}</div>
                </div>
                <van-cell
                  class="details-main-con"
                  v-for="(i, id) in item"
                  :key="id"
                >
                  <van-cell icon="underway-o" class="major-title" :class="i.url!=null?'majorTitlePr':''">
                    {{ i.startTime + '-' + i.endTime }} {{ i.roomEnTitle }}
                  </van-cell>
                  <!-- <van-cell
                    icon="underway-o"
                    class="major-title" :class="i.url!=null?'majorTitlePr':''"
                    v-if="i.startTime"
                    >{{ i.startTime + '-' + i.endTime }}</van-cell
                  > -->
                  <a :href="i.url" target="_top" v-if="i.roomEnTitle || i.roomEnName">
                    <van-cell
                      icon="location-o"
                      class="major-title" :class="i.url!=null?'majorTitlePr':''"
                      
                      >{{ i.roomEnTitle + i.roomEnName }}</van-cell
                    ></a
                  >
                  <van-cell icon="orders-o" class="major-title" :class="i.url!=null?'majorTitlePr':''">
                      <span v-html="nToBr(i.entopic)"></span>
                  </van-cell>
                  <van-cell
                    class="major-title" :class="i.url!=null?'majorTitlePr':''"
                    icon="user-o"
                    v-for="(it, is) in i.exData"
                    :key="is"
                  >
                    <div>
                      {{ it.rolename }}
                    </div>
                    <div>
                      <span
                        v-for="(s, j) in it.exenname"
                        :key="j"
                        @click="todetails(it.exid[j])"
                      >
                        <span v-html="s?nToBr(s):nToBr(it.exname[j])" style="margin-right: 5px;"></span>
                        </span
                      >
                    </div>
                  </van-cell>
                  <div class="meeting-icon" v-if="i.url!=null">
                    <a :href="i.url" target="_top">
                      <img src="../../../assets/creame2.png">  
                      <p>点击观看直播</p>
                    </a>
                  </div>
                </van-cell>
              </div>
            </div>
          </template>
      </div>
    </div>
    <van-popup
      v-model="showPopuop"
      :style="{ padding: '10%', fontSize: '14px' }"
      >无相关会议</van-popup
    >
  </div>
</template>
<script>
import commonJS from '../../../lib/signUp.js'

export default {
  name: 'searchList',

  data() {
    return {
      loading: false,
      datas: [],
      showPopuop: false,
      commonMethod: {},
      search: '',
    }
  },
  watch: {
    $route(to, from) {
      if (to.query.search != from.query.search) {
        this.search = to.query.search
        this.init()
      }
    },
  },
  created() {
    if (this.$route.query) {
      this.search = this.$route.query.search
      this.init()
    }
  },
  methods: {
    goBack(){
      this.$router.go(-1);
    },
    async init() {
      try {
        this.datas = []
        this.commonMethod = new commonJS()
        this.loading = true
        const { m, search } = this.$route.query //获得路由的参数
        const _params = Object.assign({
          m,
          dateid: 0,
          roomid: 0,
          search: String(search),
        })

        const res = await this.$http.initScheduleInfo(_params)

        if (res.Code === 1000) {
          this.$emit('searchDatas', res.childens)
          if (res.DateListEntity.length > 0 && res.DateListEntity != null) {
            let _list = []
            res.DateListEntity.map((item) => {
              let _k = []
              for (let i in item.programListEntity) {
                let _D = item.programListEntity[i]
                let { programList } = _D.programs
                for (let j in programList) {
                  let _S = programList[j]
                  //处理角色，人名
                  let exData = []
                  for (let s = 0; s < _S.expertList.length; s++) {
                    exData = this.filterRolename(_S.expertList)
                  }

                  programList[j] = {
                    url: _S.programRoom.url,
                    exData,
                    //中文
                    createdTime: this.formatDate(_S.programDate.prodate),
                    startTime: _S.starttime,
                    endTime: _S.endtime,
                    total: item.ProgramCount, //总数量
                    topic: _S.topic,
                    roomName: _S.programRoom.roomname,
                    roomTitle: _S.programRoom.roomtitle,
                    roleName: _S.expertList[0].exrolemodel.rolename,

                    //英文
                    entopic: _S.entopic,
                    roomEnName: _S.programRoom.roomenname,
                    roomEnTitle: _S.programRoom.roomentitle,
                    roleEnName: _S.expertList[0].exrolemodel.roleenname,
                  }
                  _k.push(programList[j])
                }
              }

              _list.push(_k)
            })
            this.datas = _list
            console.log(this.datas)
          } else {
            this.showPopuop = true
          }
        }
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },
    formatTime(val) {
      let et = val.split('(')
      let end = et[1].split(')')[0]
      let endtime = Number(end)
      let date = new Date(endtime)
      let h = date.getHours()
      h = h < 10 ? '0' + h : h
      let m = date.getMinutes()
      m = m < 10 ? '0' + m : m
      return h + ':' + m
    },
    formatDate(val) {
      let et = val.split('(')
      let end = et[1].split(')')[0]
      let date = new Date(Number(end))
      let month = date.getMonth() + 1
      let day = date.getDate()
      return month + '-' + day
    },
    getSubAgendaData(data) {
      let SubAgendaData = []
      for (let k = 0; k < data.length; k++) {
        let endtime = data[k].endtime,
          startime = data[k].starttime,
          children = data[k].children,
          exData = [],
          exenname = [],
          exid = [],
          roleenname = ''
        let exnameId = []
        for (let s = 0; s < data[k].expertList.length; s++) {
          exid.push(data[k].expertList[s].exid)

          exenname.push(data[k].expertList[s].exenname)
          roleenname = data[k].expertList[s].exrolemodel.roleenname
          exnameId.push({
            exname: data[k].expertList[s].exname,
            exid: data[k].expertList[s].exid,
          })

          exData = this.filterRolename(data[k].expertList)
        }

        SubAgendaData.push({
          children,
          startime,
          endtime,
          topic: data[k].topic,

          exid,
          exData,
          //英文数据 ----
          entopic: data[k].entopic,
          exenname,
          roleenname,
        })
      }
      return SubAgendaData
    },
    dealData(firstId, data) {
      let _temp = []
      for (let i = 0; i < data.length; i++) {
        if (data[i].upproid === firstId) {
          _temp.push(data.splice(i, 1)[0])
          i--
        }
      }
      for (let i = 0; i < _temp.length; i++) {
        _temp[i].children = this.dealData(_temp[i].proid, data)
      }
      return _temp
    },
    filterRolename(data) {
      let _rolenameList = [], //已去重rolename
        _rolename = [] // 所有rolename

      //去掉重复的身份（rolename）
      for (let i in data) {
        _rolename.push(data[i].exrolemodel.rolename)
        let _indexof = _rolenameList.indexOf(_rolename[i])
        if (_indexof == -1) {
          _rolenameList.push(data[i].exrolemodel.rolename)
        }
      }
      let _identityList = [] //去重后的身份和姓名总数据
      _rolenameList.forEach((item) => {
        let _identity = { rolename: '', exname: [], exenname: [], exid: [] }
        let _exname = [], //同一身份的嘉宾姓名
            _exenname = [],
          _exid = []
        for (let n in data) {
          if (item === data[n].exrolemodel.rolename) {
            _exname.push(data[n].exname)
            _identity.rolename = item
            _identity.exname = _exname
            _exenname.push(data[n].exenname)
            _identity.exenname = _exenname
            _exid.push(data[n].exid)
            _identity.exid = _exid
          }
        }
        _identityList.push(_identity)
      })

      return _identityList
    },
    convertTime(time) {
      let end = time.split('(')[1].split(')')[0]
      // 将时间戳转时间格式
      let date = new Date(Number(end))
      let h = date.getHours()
      h = h < 10 ? '0' + h : h
      let m = date.getMinutes()
      m = m < 10 ? '0' + m : m
      return h + ':' + m
    },
    /**
     * @description 进入到子路由 封装的方法
     * @param {Objcet} param 路由需要的参数
     */
    todetails(param) {
      const exid = param
      this.$router.push({
        path: '/meeting/details',
        query: { m: this.$route.query.m, exid},
      })
    },
    nToBr (str){
        if( str ){
            return str.replace(/\\n/g,'<br/>');
        }else{
            return str
        }
        
    },
  },
}
</script>
<style lang="scss">
.searchlist {
  .van-cell {
    &::after {
      width: 95%;
      margin: 0 auto;
      left: 0;
      border-bottom-color: #e2e8f0;
    }
  }
}
</style>
<style lang="scss" scoped>
.searchlist {
  width: 100%;
  height: auto;
  .details-return{
    position: fixed;
    right: 0;
    bottom: 80px;
    width: 84px;
    height: 60px;
    z-index: 100;
    background: #3b82f6;
    border-radius: 30px 0 0 30px;
    text-align: center;
    line-height: 60px;
    color: #fff;
    img{
      height: 100%;
    }
  }
  .searchlist-con {
    padding: 20px;
    .searchlist-title {
      font-size: 30px;
      margin: 10px 0px;
    }
    .details-main {
      padding-bottom: 30px;
      > div {
        background: #fff;
        margin-bottom: 24px;
        box-shadow: 0 2px 12px rgba(0,0,0,0.04);
      }
      .details-main-head {
        border-bottom: 1px solid #e2e8f0;
        padding: 16px 0px;
        display: flex;
        background: #3b82f6;
        border-radius: 12px 12px 0 0;
        .details-main-head-date {
          color: #3b82f6;
          padding: 0px 0px 0px 20px;
          font-size: 28px;
          & > .van-icon {
            font-size: 40px;
            line-height: 40px;
          }
          &:after {
            border: none;
          }
          span {
            line-height: 40px;
          }
        }
        .van-cell{
          background: none;
          color: #fff;
        }
        .details-list-num {
          width: 40px;
          height: 40px;
          font-size: 28px;
          margin-right: 20px;
          border-radius: 12px;
          color: #fff;
          text-align: center;
          line-height: 40px;
        }
      }
      .details-main-con {
        color: #1e293b;
        .meeting-icon{
          width: 150px;
          position: absolute;
          bottom: 40px;
          right: 0;
          a{
            color: #1e293b;
            display: block;
            text-align: center;
          }
          img{
            width: 90px;
          }
          p{
            font-size: 12px;
            margin-top: 8px;
          }
        }
        .major-title {
          padding: 10px 0px;
          font-size: 28px;
          color: #1e293b;
          line-height: 40px;
          > i {
            width: 40px;
            font-size: 34px;
            line-height: 40px;
          }
          > div {
            color: #1e293b;
            span {
              color: #3b82f6;
            }
          }
          &:after {
            border: 0px;
          }
        }
        .majorTitlePr{
          padding-right: 150px;
        }
      }
      ._link {
        > div {
          color: #3b82f6 !important;
        }
      }
    }
  }
}
</style>
